import { useCallback } from 'react';
import { AccountType, PixKeyTypeV3Api, PixType as PixTypeEnum } from '../../enums';
function mapV3AccountTypeToNumber(accountType) {
    const key = accountType?.toUpperCase();
    const map = {
        CURRENT: AccountType.CURRENT,
        SAVINGS: AccountType.SAVINGS,
        PAYMENTS: AccountType.PAYMENTS,
        IP: AccountType.IP,
        CACC: AccountType.CURRENT,
        SVGS: AccountType.SAVINGS,
        TRAN: AccountType.CURRENT,
    };
    return map[key] ?? AccountType.IP;
}
function mapV3PixKeyTypeToPixTypeEnum(type) {
    const upper = type?.toUpperCase();
    if (upper === PixKeyTypeV3Api.EVP || upper === PixKeyTypeV3Api.RANDOM) {
        return PixTypeEnum.RANDOM;
    }
    if (upper === PixKeyTypeV3Api.EMAIL) {
        return PixTypeEnum.EMAIL;
    }
    if (upper === PixKeyTypeV3Api.PHONE) {
        return PixTypeEnum.PHONE;
    }
    if (upper === PixKeyTypeV3Api.CPF || upper === PixKeyTypeV3Api.CNPJ) {
        return PixTypeEnum.TAX_IDENTIFIER;
    }
    if (upper === PixKeyTypeV3Api.AGENCY || upper === PixKeyTypeV3Api.BANK_ACCOUNT) {
        return PixTypeEnum.AGENCY;
    }
    if (upper === PixKeyTypeV3Api.QR_CODE || upper === PixKeyTypeV3Api.QRCODE) {
        return PixTypeEnum.QR_CODE;
    }
    return PixTypeEnum.RANDOM;
}
export function mapGetPixKeyDetailsV3ToPixKeyDetails(raw) {
    return {
        name: raw.name,
        taxIdentifier: raw.taxIdentifier,
        bank: raw.bank,
        account: raw.account,
        branch: raw.branch,
        accountType: mapV3AccountTypeToNumber(raw.accountType),
        bankId: raw.bankId,
        endToEndId: raw.endToEndId,
        type: mapV3PixKeyTypeToPixTypeEnum(raw.type),
        key: raw.key,
        protocolId: '',
    };
}
export function useMapGetPixKeyDetailsV3ToPixKeyDetails() {
    return useCallback(mapGetPixKeyDetailsV3ToPixKeyDetails, []);
}
